import { jsxs as i, jsx as l } from "react/jsx-runtime";
import { useBreakpointValue as F, useMultiStyleConfig as H, Modal as S, ModalOverlay as v, ModalContent as D, ModalHeader as O, ModalBody as V, ModalFooter as q } from "@chakra-ui/react";
import { ModalHeaderIcon as w } from "./ModalHeaderIcon.mjs";
import { ModalDefaultFooter as A } from "./ModalDefaultFooter.mjs";
import { CloseButton as E } from "../../dataDisplay/CloseButton/CloseButton.mjs";
const G = (a, t) => {
  let r = "xl";
  return a ? r = "full" : t && (r = "sm"), r;
}, Q = ({
  autoFocus: a = !0,
  children: t,
  closeOnEsc: r = !0,
  closeOnOverlayClick: f = !0,
  "data-testid": o,
  footer: d,
  id: M,
  isCentered: c = !1,
  isFullScreen: u = !1,
  isOpen: p,
  modalContentProps: b,
  modalHeaderProps: h,
  onCancelClick: x,
  onClose: n,
  onContinueClick: y,
  onEsc: z,
  onOverlayClick: B,
  scrollBehavior: C,
  showCloseButton: $ = !0,
  status: e,
  title: s,
  useInert: k = !0,
  ...g
}) => {
  const m = F({ base: !0, md: !1 }, { fallback: "md" }), j = H("Modal");
  return /* @__PURE__ */ i(
    S,
    {
      id: M,
      isOpen: p,
      onClose: n,
      closeOnEsc: r,
      closeOnOverlayClick: f,
      isCentered: c,
      onEsc: z,
      onOverlayClick: B,
      scrollBehavior: C,
      useInert: k,
      size: G(u, m),
      autoFocus: a,
      children: [
        /* @__PURE__ */ l(v, {}),
        /* @__PURE__ */ i(
          D,
          {
            "data-testid": o,
            ...e && { "data-status": e },
            ...b,
            ...g,
            children: [
              s && /* @__PURE__ */ i(
                O,
                {
                  "data-testid": o && `${o}-header`,
                  ...e && { "data-status": e },
                  ...h,
                  children: [
                    e && /* @__PURE__ */ l(w, { status: e }),
                    s
                  ]
                }
              ),
              $ && /* @__PURE__ */ l(
                E,
                {
                  sx: j.closeButton,
                  "aria-label": "Close",
                  size: m ? "sm" : "md",
                  onClick: n
                }
              ),
              /* @__PURE__ */ l(
                V,
                {
                  "data-testid": o && `${o}-body`,
                  ...e && { "data-status": e },
                  children: t
                }
              ),
              /* @__PURE__ */ l(q, { "data-testid": o && `${o}-footer`, children: d || /* @__PURE__ */ l(A, { onCancelClick: x, onContinueClick: y }) })
            ]
          }
        )
      ]
    }
  );
};
export {
  Q as Modal
};
